import softwareIndex from '@/views/recognize/software/softwareIndex.vue'
export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'softwareIndex',
      name: 'softwareIndex',
      component: softwareIndex
    }

  ]
}
